const breakpointValues = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1025,
    xl: 1400,
    xxl: 1600,
};

const breakpoints = {
    xs: `${breakpointValues.xs}px`,
    sm: `${breakpointValues.sm}px`,
    md: `${breakpointValues.md}px`,
    lg: `${breakpointValues.lg}px`,
    xl: `${breakpointValues.xl}px`,
    xxl: `${breakpointValues.xxl}px`,

    deskWideWithGutters: `${breakpointValues.xl + 40}px`,
    maxWithGutters: `${breakpointValues.xxl + 40}px`,
};

module.exports = breakpoints;
